<template>
  <div
    ref="draggableContainer"
    class="draggable-container"
    draggable="true"
    @mousedown="dragStart"
    @mouseup="dragEnd"
    @mousemove="drag"
  >
    <slot>
      <div class="draggable-container__default">
        Default draggable object.
      </div>
    </slot>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isDragging: false,
      currentX: 0,
      currentY: 0,
      initialX: 0,
      initialY: 0,
      xOffset: 0,
      yOffset: 0,
    };
  },
  methods: {
    dragStart(event) {
      this.isDragging = true;
      this.initialX = event.clientX - this.xOffset;
      this.initialY = event.clientY - this.yOffset;

      if (event.target === this.$refs.draggableContainer) {
        this.$el.style.cursor = 'grabbing';
      }
    },
    dragEnd() {
      this.isDragging = false;
    },
    drag(event) {
      if (this.isDragging) {
        event.preventDefault();
        this.currentX = event.clientX - this.initialX;
        this.currentY = event.clientY - this.initialY;
        this.xOffset = this.currentX;
        this.yOffset = this.currentY;
        this.$el.style.transform = `translate3d(${this.currentX}px, ${this.currentY}px, 0)`;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.draggable-container {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2000;
  cursor: grab;

  .draggable-container__default {
    padding: 1rem;
    background-color: #fff;
    border: 1px solid #ccc;
    border-radius: 0.25rem;
  }
}

</style>
